module.exports = __webpack_public_path__ + "static/29-deerhunter-a09dee10dea4897523fe41e535c44352.jpg";